import {ChangeDetectionStrategy, Component, effect} from '@angular/core';
import {StudentEnrollmentService} from "../../services/student-enrollment.service";
import {RouterLink} from "@angular/router";
import {lineSpinner} from "ldrs";
// import {JsonPipe} from "@angular/common";
import {FormatDatePipe} from "../../pipes/date-format.pipe";
import {FormatTimePipe} from "../../pipes/time-format.pipe";


@Component({
    selector: 'app-my-classes',
    imports: [
        RouterLink,
        FormatDatePipe,
        FormatTimePipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './my-classes.component.html',
    styleUrl: './my-classes.component.scss'
})
export class MyClassesComponent {

    constructor(
        private enrollment: StudentEnrollmentService
    ) {}
    ngOnInit() {
        lineSpinner.register();
        this.enrollment.myClasses$.subscribe((classes:any) => {
            if ( classes == null ) {
                this.enrollment.processClasses();
            }
        });
    }
    public get classScheduleState() {
        return this.enrollment.classScheduleState();
    }
    public get classes() {
        if ( this.enrollment.myClasses() != null ) {
            return this.enrollment.myClasses();
        }
        return [];
    }
    public eventHasDayOfWeek(days:string[],day:string) {
        return days.includes(day);
    }
}
